import { render, staticRenderFns } from "./SummarySection.vue?vue&type=template&id=e0208f16&scoped=true"
import script from "./SummarySection.vue?vue&type=script&lang=js"
export * from "./SummarySection.vue?vue&type=script&lang=js"
import style0 from "./SummarySection.vue?vue&type=style&index=0&id=e0208f16&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0208f16",
  null
  
)

export default component.exports